import {ApplicationTypes, BoolLike, BuildType, EmploymentTypes, MortgageTypes, PersonalMaritalStatuses} from "../../../../models";
import dayjs from "dayjs";

const names = [
	"P1 Fully complete form 1",
	"P1 Photo ID 1",
	"P1 Proof address 1",
	"P1 Proof PPSN 1",
	"P1 Stamped salary cert 1",
	"P1 Two months payslips 1",
	"P1 6 months acc statements 1",
	"P1 6 months savings acc 1",
	"P1 BER Cert 1",
	"P1 BER Cert 2",
	"P1 6 months savings acc 2",
	"P1 6 months acc statements 2",
	"P1 Two months payslips 2",
	"P1 Stamped salary cert 2",
	"P1 Proof PPSN 2",
	"P1 Proof address 2",
	"P1 Photo ID 2",
	"P1 Fully complete form 2",
	"P1 Borrower app of own accord YN",
	"P1 Applicants non resident YN",
	"P2 Revenue emp summary 1",
	"P2 Divorce agreement 1",
	"P2 Statement rental 1",
	"P2 Shared equity cert 1",
	"P2 Housing scheme app cert 1",
	"P2 Help to buy app 1",
	"P2 Financial acc 1",
	"P2 Form 11 revenue 1",
	"P2 Rev notice assess",
	"P2 Current acc statements 1",
	"P2 Tax up to date 1",
	"P2 Architect Surveyor 1",
	"P2 Planning permission 1",
	"P2 Initial valuation 1",
	"P2 Memo included 1",
	"P2 Repayment capacity 1",
	"P2 Funding demonstrated 1",
	"P2 Funding demonstrated 2",
	"P2 Repayment capacity 2",
	"P2 Memo included 2",
	"P2 Initial valuation 2",
	"P2 Planning permission 2",
	"P2 Architect Surveyor 2",
	"P2 Tax up to date 2",
	"P2 Current acc statements 2",
	"P2 Rev notice assess 1",
	"P2 Form 11 revenue 2",
	"P2 Financial acc 2",
	"P2 Help to buy app 2",
	"P2 Housing scheme app cert 2",
	"P2 Shared equity cert 2",
	"P2 Statement rental 2",
	"P2 Divorce agreement 2",
	"P2 Revenue emp summary 2",
	"P2 Advisor name",
	"P2 Date DD",
	"P2 Date MM",
	"P2 Date YYYY",
]

export default function (mortgage, config) {
    let legacyEmployment = !mortgage[`applicant1`].employmentIncome?.length || !mortgage[`applicant1`].employmentIncome[0].employmentType
    let paye1
    let self1
    let paye2
    let self2
    const appVariableUsed = (n) => {
		let testedVariable
		if (mortgage.activeSubmission?.verifiedFiguresTest){
			testedVariable = mortgage.activeSubmission?.verifiedFiguresTest.test.variableUsed
		}
		else{
			testedVariable = mortgage.activeSubmission?.provisionalXlsInput.figures[`variable${n}`]
		}
        return testedVariable > 0
    }
    if (legacyEmployment){
        paye1 = (mortgage.applicant1.employment.employmentType === EmploymentTypes.EMPLOYED)
        self1 = (mortgage.applicant1.employment.employmentType === EmploymentTypes.SELFEMPLOYED)
        if (mortgage.twoApplicants){
            paye2 = mortgage.applicant2.employment.employmentType === EmploymentTypes.EMPLOYED
            self2 = mortgage.applicant2.employment.employmentType === EmploymentTypes.SELFEMPLOYED
        }
    }
    else{
        paye1 = !!mortgage.applicant1.employmentIncome.find(e=>e.employmentType === EmploymentTypes.EMPLOYED)
        self1 = !!mortgage.applicant1.employmentIncome.find(e=>e.employmentType === EmploymentTypes.SELFEMPLOYED)
        if (mortgage.twoApplicants){
            paye2 = !!mortgage.applicant2.employmentIncome.find(e=>e.employmentType === EmploymentTypes.EMPLOYED)
            self2 = !!mortgage.applicant2.employmentIncome.find(e=>e.employmentType === EmploymentTypes.SELFEMPLOYED)
        }
    }

    let map = {}
	let fill = {}
	let ask = []

    const page1 = ()=>{
		//fill['P1 Applicants non resident YN'] = {check: 'N'}
		if (mortgage.applicant1.personal.countryOfResidence !== "IE" || ( mortgage.twoApplicants && mortgage.applicant2.personal.countryOfResidence !== "IE") || mortgage.applicant1.personal.dualResidency || ( mortgage.twoApplicants && mortgage.applicant2.personal.dualResidency)){
            map['non-or-dual-resident-yes'] = true
            map['confirm-no-foreign-services-yes'] = true
            fill['P1 Applicants non resident YN'] = {check: true}
			fill['P1 Borrower app of own accord YN'] = {check: true}
		}
		else{
            map['non-or-dual-resident-no'] = true
			fill['P1 Applicants non resident YN'] = {check: false}
			fill['P1 Borrower app of own accord YN'] = {check: false}
		}
        fill['P1 Fully complete form 1'] = {check: true}
        fill['P1 Photo ID 1'] = {check: true}
        fill['P1 Proof address 1'] = {check: true}
        fill['P1 Proof PPSN 1'] = {check: true}
        if (paye1){
            fill['P1 Stamped salary cert 1'] = {check: true}
        }
        fill['P1 Two months payslips 1'] = {check: true}
        fill['P1 6 months acc statements 1'] = {check: true}
        if (mortgage.applicant1.assets.length){
            fill['P1 6 months savings acc 1'] = {check: true}
        }
        if (mortgage.mortgageType === MortgageTypes.PURCHASE && [ApplicationTypes.FIRSTTIME,ApplicationTypes.MOVINGHOME].includes(mortgage.applicationType)){
            if (mortgage.property?.addressKnown){
                fill['P1 BER Cert 1'] = {check: true}
            }
        }


        if (mortgage.twoApplicants) {
            fill['P1 Fully complete form 2'] = {check: true}
            fill['P1 Photo ID 2'] = {check: true}
            fill['P1 Proof address 2'] = {check: true}
            fill['P1 Proof PPSN 2'] = {check: true}
            if (paye2){
                fill['P1 Stamped salary cert 2'] = {check: true}
            }
            fill['P1 Two months payslips 2'] = {check: true}
            fill['P1 6 months acc statements 2'] = {check: true}
            if (mortgage.applicant2.assets.length){
                fill['P1 6 months savings acc 2'] = {check: true}
            }
        }
    }
	const page2 = ()=>{
		const section1 = () =>{
			if (appVariableUsed(1)){
				fill['P2 Revenue emp summary 1'] = {check: true}
			}
			if ([PersonalMaritalStatuses.REMARRIED, PersonalMaritalStatuses.DIVORCED, PersonalMaritalStatuses.SEPARATED].includes(mortgage.applicant1.personal.maritalStatus)){
				fill['P2 Divorce agreement 1'] = {check: true}
			}
			if ((mortgage.applicant1.properties||[]).find(p=>p.isRented)) {
				fill['P2 Statement rental 1'] = {check: true}
			}

			if (mortgage.twoApplicants){
				if (appVariableUsed(2)){
					fill['P2 Revenue emp summary 2'] = {check: true}
				}
				if ([PersonalMaritalStatuses.REMARRIED, PersonalMaritalStatuses.DIVORCED, PersonalMaritalStatuses.SEPARATED].includes(mortgage.applicant2.personal.maritalStatus)){
					fill['P2 Divorce agreement 2'] = {check: true}
				}
				if ((mortgage.applicant2.properties||[]).find(p=>p.isRented)) {
					fill['P2 Statement rental 2'] = {check: true}
				}
			}

			if (mortgage.requirement.firstHomeScheme === BoolLike.TRUE){
				fill['P2 Shared equity cert 1'] = {check: true}
				// if (mortgage.twoApplicants){
				// 	fill['P2 Shared equity cert 2'] = {check: true}
				// }
			}

			if (mortgage.requirement.helpToBuy !== BoolLike.FALSE){
                const hasHTB = mortgage.uploadSections.filter(it=>it.name === 'htb-scheme-forms' && it.isActive).some(section=>{
                    return section.activeUploads.length
                })
                if (hasHTB){
                    fill['P2 Help to buy app 1'] = {check: true}
                }

				// if (mortgage.twoApplicants){
				// 	fill['P2 Help to buy app 2'] = {check: true}
				// }
			}
		}
		const section2 = () =>{
			if (self1){
				fill['P2 Financial acc 1'] = {check: true}
				fill['P2 Form 11 revenue 1'] = {check: true}
				fill['P2 Rev notice assess'] = {check: true}
				fill['P2 Current acc statements 1'] = {check: true}
				fill['P2 Tax up to date 1'] = {check: true}
			}
			if (mortgage.twoApplicants && self2){
				fill['P2 Financial acc 2'] = {check: true}
				fill['P2 Form 11 revenue 2'] = {check: true}
				fill['P2 Rev notice assess 1'] = {check: true}
				fill['P2 Current acc statements 2'] = {check: true}
				fill['P2 Tax up to date 2'] = {check: true}
			}
		}
		const section3 = () =>{
			if (mortgage.property.buildType === BuildType.SELFBUILD){
				fill['P2 Architect Surveyor 1'] = {check: true}
				fill['P2 Planning permission 1'] = {check: true}
				fill['P2 Initial valuation 1'] = {check: true}
			}
		}
		const section4 = () =>{
			fill['P2 Memo included 1']= {check: true}
			fill['P2 Repayment capacity 1']= {check: true}
			fill['P2 Funding demonstrated 1'] = {check: true}
		}
		const section5 = () =>{
			let d = dayjs()
			fill['P2 Advisor name'] = {string: 'Kevin Coakley'}
			fill['P2 Date DD'] = {string: d.format('DD')}
			fill['P2 Date MM'] = {string: d.format('MM')}
			fill['P2 Date YYYY'] = {string: d.format('YYYY')}
		}
		section1()
		section2()
		section3()
		section4()
		section5()

    }

	page1()
	page2()

	return {
		sections: [
			{
				fill,
				ask,
				map
			}
		]
	}
}

